<template>
    <section class="addquest-autocomplete-list-item"
             :class="{ 'user-assigned-to-mic': isAssigned, 'user-clickable': isClickable }"
             @click="handleClick">
        <section class="addquest-autocomplete-list-item-user-data">
            <section class="addquest-autocomplete-list-item-user-data-username">
                <section class="addquest-autocomplete-list-item-user-avatar">
                    <img v-if="$store.state.settings.runtime.interactiveDiscussionShowAvatar && user.uid"
                         :src="getUserAvatar(user.id)"
                         class="addquest-autocomplete-list-item-user-avatar-img" />
                    <section class="addquest-autocomplete-list-item-user-name">
                        <span>{{ user.name }}</span> <span>{{ user.lastName }}</span>
                    </section>
                    <section class="addquest-autocomplete-list-item-user-data-role" v-if="user.function">
                        {{ user.function }}
                    </section>
                </section>
            </section>
        </section>
    </section>
</template>

<script charset="utf-8">
    export default {
        name: "UserForMicrophoneItem",
        props: {
            user: {
                type: Object,
                required: true,
            },
            isAssigned: {
                type: Boolean,
                default: false
            },
            isEditMode: {
                type: Boolean,
                default: false
            },
            selectedMicrophoneId: {
                type: [Number, String],
                default: null
            }
        },
        computed: {
            isClickable() {
                return this.isEditMode && this.selectedMicrophoneId != null
            }
        },
        emits: ['click'],
        methods: {
            getUserAvatar(id) {
                return `https://ssl.esesja.pl/users/${id}.jpg`;
            },
            handleClick() {
                if (this.isClickable) {
                    this.$emit('click', this.user.id)
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/assets/scss/discussion-quest-item.scss';
</style>

